// Every page takes the default title and description unless it has its own key.
export default {
  default: {
    title: 'NeatDocs — Document Organization for Freelancers & Solopreneurs | Neat',
    description: 'NeatDocs gives freelancers and solopreneurs a secure home for every receipt, bill, and document. Auto-classify, organize, and email your accountant in seconds. Start free.',
    twitter: {
      cardType: 'summary_large_image',
      site: '@neatcompany',
      handle: '@neatcompany',
    },
    openGraph: {
      locale: 'en_US',
      site_name: 'The Neat Company',
    },
  },
  emailPreferences: {
    title: 'Email Preferences | The Neat Company',
    description: "Subscribe to or unsubscribe from Neat's marketing emails.",
  },
  ourHistory: {
    title: 'Our History | Neat',
    description: 'Our vision is to accelerate small businesses\' transition to a world where keeping books is simple, frictionless, instant, and automated.',
  },
  policies: {
    title: 'Neat Policies | The Neat Company',
    description: "Neat's terms and conditions, privacy policy, sales tax policy and email preferences.",
  },
  privacy: {
    title: 'Privacy Policy | The Neat Company',
    description: "Neat's privacy policy.",
  },
  policiesSalesTax: {
    title: 'Sales Tax Policy | The Neat Company',
    description: "Neat's sales tax policy.",
  },
  termsConditions: {
    title: 'Terms & Conditions | The Neat Company',
    description: "Neat's terms and conditions.",
  },
}
